/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Checkbox } from '@mantine/core'

function MissingDataFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Checkbox
        checked={value === 'true'}
        id="missing_data_filter"
        label={intl.formatMessage({
          id: 'missing_data',
          defaultMessage: 'Données manquantes'
        })}
        name="missingData"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
    </Filter>
  )
}

export default MissingDataFilter
